import React, { useEffect, useState, useContext } from "react";
import styles from "./PopNFT.module.scss";
import goldVideo from '../../assets/imgs/nft/videos/Tower_Goldchest_openingV2_compressed.mp4';
import silverVideo from '../../assets/imgs/nft/videos/Tower_Silverchest_openingV2_compressed.mp4';
import bronzeVideo from '../../assets/imgs/nft/videos/Tower_Bronzechest_openingV2_compressed.mp4';
import goldVideoMobile from '../../assets/imgs/nft/videos/Tower_Goldchest_opening_MobileV2_compressed.mp4';
import silverVideoMobile from '../../assets/imgs/nft/videos/Tower_Silverchest_opening_MobileV2_compressed.mp4';
import bronzeVideoMobile from '../../assets/imgs/nft/videos/Tower_Bronzechest_opening_MobileV2_compressed.mp4';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { TokenContext } from '../../components/Context';
import ReactPlayer from 'react-player';

const PopNFT = () => {
    const { t } = useTranslation();
    const [chestOpened, setChestOpened] = useState(false);
    const history = useHistory();
    const [{
        openChest,
        latestCardDetails
    }] = useContext(TokenContext);
    const [mode, setMode] = useState("");
    const [latestCards, setLatestCards] = useState([]);

    useEffect(() => {
        if (openChest) {
            setMode(openChest);
            // setMaxChest(chestBalance.matic[openChest]);
        } else {
            history.push('/inventory/chests');
        }
    }, [openChest]);

    // Preloading card images which gets stored in cache
    useEffect(() => {
        let lastestCardArray = Object.keys(latestCardDetails).map((k) => latestCardDetails[k]);
        
        for (let cardDetail of lastestCardArray) {
            const img = new Image();
            img.src = cardDetail.image;
        }

        setLatestCards(lastestCardArray);
    }, [latestCardDetails]);

    // const getTransformOrigin = (idx) => {
    //     const n = (latestCards.length - 1) / idx;
    //     return n === 2 ? '50% 100%' : n < 2 ? '0% 100%' : '100% 100%'
    // }

    return (
        <div className={styles.container}>
            {mode === "gold" && (
                <ReactPlayer
                    className={styles.videoFrame}
                    playing={!!latestCards.length}
                    muted
                    url={window.screen.width <= 1024 ? goldVideoMobile : goldVideo}
                    width="100%"
                    height="100%"
                    onProgress={({ playedSeconds }) => {
                        if (!chestOpened && playedSeconds > 3.6) {
                            setChestOpened(true);
                        }
                    }}
                    progressInterval={ 1 }
                />
            )}
            {mode === "silver" && (
                <ReactPlayer
                    className={styles.videoFrame}
                    playing={!!latestCards.length}
                    muted
                    url={window.screen.width <= 1024 ? silverVideoMobile : silverVideo}
                    width="100%"
                    height="100%"
                    onProgress={({ playedSeconds }) => {
                        if (!chestOpened && playedSeconds > 3.6) {
                            setChestOpened(true);
                        }
                    }}
                    progressInterval={ 1 }
                />
            )}
            {mode === "bronze" && (
                <ReactPlayer
                    className={styles.videoFrame}
                    playing={!!latestCards.length}
                    muted
                    url={window.screen.width <= 1024 ? bronzeVideoMobile : bronzeVideo}
                    width="100%"
                    height="100%"
                    onProgress={({ playedSeconds }) => {
                        if (!chestOpened && playedSeconds > 3.6) {
                            setChestOpened(true);
                        }
                    }}
                    progressInterval={ 1 }
                />
            )}
            {chestOpened && (
                <div className={styles.nft_container}>
                    <div className={styles.nft_wrapper}>
                        {
                            latestCards && latestCards.map((cardDetail, idx) => (
                                <div className={`${styles.chestWrapper} ${styles[`chestWrapper${idx + 1}`]}`} key={idx}>
                                    <div
                                        className={styles.cardImageWrapper}
                                    >
                                        <img src={cardDetail.image} alt={cardDetail.name} />
                                    </div>
                                    <div className={`${styles.chestInfo1} ${styles.chestText}`}>{cardDetail.name}</div>
                                </div>
                            ))
                        }
                    </div>
                    <div className={styles.button_wrapper}>
                        <Button className={styles.back} onClick={() => history.push('/inventory/chests')}>
                            {t('Back to Chests')}
                        </Button>
                        <Button className={styles.view} onClick={() => history.push('/inventory/cards')}>
                            {t('View my items')}
                        </Button>
                    </div>
                </div>
            )}
        </div >
    )
}

export { PopNFT }
